module.exports = __webpack_public_path__ + "img/20.ee3e92c8.png";